import Product from '../../domains/Product'
import { getSearchParams } from '../../helpers/url-search/get-search-params'
import { isProd } from '../../utils/isEnv'

import { TRUE_FIT_ENABLED_DIVISIONS, TRUE_FIT_ENABLED_DEPARTMENTS } from './true-fit.constants'

export const EXPERIMENT_KEYS = {
  REGISTRATION_TREATMENT: isProd ? 'sj62ikof' : 'ru35a3im',
}

const isTruefitEnabledProduct = (product: Product) => {
  const division = product.classification?.division?.id
  const truefitEnabledDivision = division ? TRUE_FIT_ENABLED_DIVISIONS.includes(division) : false

  const department = product.classification?.department?.id
  const truefitEnabledDepartment =
    truefitEnabledDivision && department ? TRUE_FIT_ENABLED_DEPARTMENTS.includes(department) : false

  return truefitEnabledDivision && truefitEnabledDepartment
}

const isTrueFitDisabledByUrl = (): boolean => {
  const disableTrueFitUrlParam = getSearchParams('disableTrueFit')
  if (disableTrueFitUrlParam === 'true') return true
  return false
}

export const shouldShowTruefitWidget = (product: Product | undefined): boolean => {
  if (isTrueFitDisabledByUrl()) return false
  return (product && isTruefitEnabledProduct(product)) || false
}
